/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import analyticsTracking from 'src/services/analytics-service';

const useHelpAppAnalytics = () => {
  const trackTopLevelMenu = (navLabel: string) => {
    analyticsTracking.trackEvent({
      category: 'help_mega_nav',
      label: navLabel,
      action: 'opened'
    });
  };

  const trackMegaNavItemClick = (linkLabel: string, type: string) => {
    const action =
      type === 'article' ? 'text_article_opened' : 'video_article_opened';
    analyticsTracking.trackEvent({
      category: 'help_mega_nav',
      label: linkLabel,
      action
    });
  };

  return {
    trackTopLevelMenu,
    trackMegaNavItemClick
  };
};
export default useHelpAppAnalytics;
